"use client"

import { GetPageQuery } from "apollo";
import { ScrollingProvider } from "contexts/ScrollingContext";
import { Article } from "lib/articles";
import dynamic from "next/dynamic";
import { Desktop, Mobile } from "ui";
import { BlockRenderer, extractProperty, findProperty } from "utils";
import HeroOneImage from "./HeroOneImageCharge";
import QRCodeCharge from "./QRCodeCharge";
import StickyButtonNav from "./SitckyButtonNavigatorCharge";

const ImageWithTextHomeCharge = dynamic(() => import("./ImageWithTextHomeCharge"));
const QuestionListBlockCharge = dynamic(() => import("./QuestionListBlockCharge"));
const StationTypeCharge = dynamic(() => import("./ServiceTypeCharge"));
const UsefulInfoBlockCharge = dynamic(() => import("./UsefulInfoBlockCharge"));
const VideoBlockCharge = dynamic(() => import("./VideoBlockCharge"));

type Props = {
    data: GetPageQuery
    articles: Article[]
}

const components = {
    chargeHomeHeader: HeroOneImage,
    chargeVideoBlock: VideoBlockCharge,
    chargeServiceType: StationTypeCharge,
    imageTextBlock1: ImageWithTextHomeCharge,
    chargeQuestionsList: QuestionListBlockCharge,
    chargeUsefulInfoBlock: UsefulInfoBlockCharge
}

export const LARGE_DESKTOP_CONT_WIDTH = 1320
export const MEDIUM_DESKTOP_CONT_WIDTH = 800

function HomePageCharge({ data, articles }: Props) {
    const pageName = extractProperty(data?.page, "pageName")
    return (<>
        <Desktop>
            <QRCodeCharge showScrollIcon minYOffset={400} showInDefault={false} ></QRCodeCharge>
        </Desktop>
        <Mobile>
            <StickyButtonNav />
            <QRCodeCharge showQRCode={false} showScrollIcon></QRCodeCharge>
        </Mobile>

        <ScrollingProvider pageName={pageName} minOffsetShow={600} smallDesktopMaxWidth={200}>
            {findProperty(data?.page, "blocks")?.blocks?.map(
                // TO DO : HOW TO FIND BLOCK TYPE IN GENERATED GRAPHQL TYPES
                (block: any, index: number) => {
                    let addProp = {}
                    const sideMenuTitle = block.properties.find(
                        (prop: any) => prop.propertyName === "sideMenuTitle",
                    )?.propertyValue?.value
                    if (block.blockType === "chargeUsefulInfoBlock") {
                        addProp = {
                            articles: articles,
                        }
                    }
                    return (
                        <section key={index} id={sideMenuTitle || `page : ${index.toString()}`}>
                            <BlockRenderer
                                index={index}
                                key={index}
                                blockType={block.blockType}
                                blockData={block}
                                components={components}
                                props={addProp}
                            >
                            </BlockRenderer>
                        </section>
                    )
                },
            )}
        </ScrollingProvider>
    </>);
}

export default HomePageCharge;
